
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Urbaniaonrentinpune() {



    const cardData =
    {
        keyword: '  Urbania On Rent In Pune',
        heading: 'Samarth Travels: Urbania On Rent In Pune',
        headingDescription: 'Samarth Travels offers Urbania on rent in Pune, ideal for local sightseeing, outstation trips, corporate travel, and group tours. Our premium Force Urbania vehicles feature air-conditioning, comfortable push-back seats, and spacious interiors to ensure a relaxed and enjoyable journey. With professional drivers, transparent pricing, and a commitment to customer satisfaction, Samarth Travels guarantees a smooth and memorable travel experience.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Urbania on Rent in Pune",
        "description": "Samarth Travels offers Urbania on rent in Pune for a variety of travel needs. Whether it's a local trip or a special event, our Urbania vehicles provide a smooth and comfortable ride for passengers."
    },
    {
        "name": "Urbania Rental Services in Pune",
        "description": "Get reliable Urbania rental services in Pune with Samarth Travels. Our well-maintained Urbania fleet is ideal for family trips, group tours, and professional travel needs within the city."
    },
    {
        "name": "Urbania Vehicle Hire Pune",
        "description": "Hire an Urbania vehicle in Pune with Samarth Travels for your next journey. Our vehicles are equipped for comfort and safety, making them suitable for both short and long-distance travel."
    },
    {
        "name": "Urbania on Rent for Weddings in Pune",
        "description": "Make your wedding transportation seamless with our Urbania rental for weddings in Pune. Perfect for guest transfers, our Urbania vans offer style and comfort to enhance your special day."
    },
    {
        "name": "Urbania Rent for Corporate Events Pune",
        "description": "Samarth Travels offers Urbania rental for corporate events in Pune. Whether it’s a seminar or client meeting, our Urbania vans ensure professional, punctual, and comfortable transport."
    },
    {
        "name": "Luxury Urbania on Rent in Pune",
        "description": "Travel in style with our luxury Urbania on rent in Pune. Ideal for premium events and VIP travel, our luxury Urbania vans come with high-end features for a superior travel experience."
    },
    {
        "name": "Urbania 14 Seater on Rent in Pune",
        "description": "Samarth Travels provides Urbania 14-seater rentals in Pune for medium-sized groups. Enjoy ample space, air-conditioning, and a smooth ride, perfect for group outings or event transfers."
    },
    {
        "name": "Urbania for City Tours in Pune",
        "description": "Explore Pune in comfort with our Urbania city tour rentals. Perfect for sightseeing with friends or family, our Urbania vehicles ensure a relaxing and enjoyable city tour experience."
    },
    {
        "name": "Urbania Hire in Pune for Picnics",
        "description": "Planning a picnic? Hire an Urbania in Pune with Samarth Travels. Our vehicles are perfect for group outings, offering spacious interiors and comfortable seating for the whole group."
    },
    {
        "name": "Urbania on Rent Pune to Outstation",
        "description": "Travel outstation from Pune in comfort with our Urbania rental service. Ideal for long-distance group travel, our Urbania vans ensure a smooth and relaxing journey beyond city limits."
    },
    {
        "name": "Urbania Rental Price in Pune",
        "description": "Looking for affordable Urbania rental prices in Pune? Samarth Travels offers competitive rates for Urbania hire, ensuring cost-effective transportation without compromising on quality."
    },
    {
        "name": "Urbania Bus Hire Pune",
        "description": "For group transportation, opt for Urbania bus hire in Pune. Our spacious Urbania vehicles are perfect for corporate trips, family outings, and special occasions."
    },
    {
        "name": "Urbania for Local Sightseeing in Pune",
        "description": "Enjoy hassle-free local sightseeing in Pune with Samarth Travels’ Urbania rentals. Our vehicles are perfect for exploring the city’s attractions comfortably and efficiently."
    },
    {
        "name": "Urbania for Airport Transfers Pune",
        "description": "Ensure timely and stress-free airport transfers in Pune with our Urbania rentals. Spacious and reliable, our vehicles are ideal for picking up or dropping off guests or business clients."
    },
    {
        "name": "Urbania for Family Trips in Pune",
        "description": "Plan your next family outing with our Urbania rentals in Pune. Offering space, comfort, and reliability, our vehicles make family trips more enjoyable and convenient."
    },
    {
        "name": "Urbania for Group Travel Pune",
        "description": "Samarth Travels offers Urbania rentals for group travel in Pune. Whether for leisure or business, our vehicles are equipped to handle group transport efficiently and comfortably."
    },
    {
        "name": "Urbania Rent for Long Trips Pune",
        "description": "Planning a long journey? Rent an Urbania in Pune with Samarth Travels. Our comfortable and spacious Urbania vans are perfect for extended travel with friends, family, or colleagues."
    }
],
"tableData": [
    ["Urbania on Rent in Pune", "Urbania Rental Services in Pune"],
    ["Urbania Vehicle Hire Pune", "Urbania on Rent for Weddings in Pune"],
    ["Urbania Rent for Corporate Events Pune", "Luxury Urbania on Rent in Pune"],
    ["Urbania 14 Seater on Rent in Pune", "Urbania for City Tours in Pune"],
    ["Urbania Hire in Pune for Picnics", "Urbania on Rent Pune to Outstation"],
    ["Urbania Rental Price in Pune", "Urbania Bus Hire Pune"],
    ["Urbania for Local Sightseeing in Pune", "Urbania for Airport Transfers Pune"],
    ["Urbania for Family Trips in Pune", "Urbania for Group Travel Pune"],
    ["Urbania Rent for Long Trips Pune", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Force Urbania Rental Service in Pune",
        "WhyChoosedescription": "We provide reliable and professional Force Urbania van rental services in Pune for all types of events. Whether it’s a family outing, corporate seminar, or group travel, we ensure timely, comfortable, and organized transportation to make your journey smooth and hassle-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Force Urbania Vans for All Group Sizes",
        "WhyChoosedescription": "Our fleet includes a variety of Force Urbania vans, ranging from 9-seater to 17-seater options. Each van is equipped with reclining seats, ample legroom, air-conditioning, and charging ports to ensure your passengers enjoy a relaxed ride, regardless of the journey's length."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers for Smooth Journeys",
        "WhyChoosedescription": "Our drivers are well-trained professionals, courteous, punctual, and familiar with the roads and event venues across Pune. With their expertise, you can rest assured that your group will be transported safely and on time."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Force Urbania Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing with no hidden charges. Whether you need an Urbania for a few hours or the entire day, our flexible rental packages are designed to fit your budget while maintaining the highest quality of service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Event and Travel Schedule",
        "WhyChoosedescription": "Events can happen at any time, and so can our services. We offer 24/7 availability for Force Urbania rentals, allowing you to schedule transportation at your convenience, be it early morning or late at night."
    },
    {
        "WhyChooseheading": "Simple and Hassle-Free Booking with Real-Time Updates",
        "WhyChoosedescription": "Booking your Force Urbania rental is easy and quick through our website or customer support. After booking, you’ll receive real-time tracking, driver contact information, and updates on the vehicle’s arrival, ensuring seamless coordination."
    },
    {
        "WhyChooseheading": "Well-Maintained, Clean, and Sanitized Force Urbania Vans",
        "WhyChoosedescription": "All our Force Urbania vans are maintained to the highest standards of cleanliness and safety. Each vehicle is thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe environment for your passengers."
    },
    {
        "WhyChooseheading": "Multiple Convenient Payment Options for Booking",
        "WhyChoosedescription": "We offer a range of payment options including UPI, credit/debit cards, digital wallets, and cash, providing you with the flexibility to complete your booking securely and easily."
    }
]


















    }

const faqData = [
    {
        id: 1,
        question: 'How do I rent a Force Urbania van in Pune with Samarth Travels?',
        answer: 'You can easily rent a Force Urbania van by contacting Samarth Travels through our website or by phone. Share your travel details such as date, pickup point, and passenger count, and we’ll arrange a comfortable Urbania van for your journey.',
    },
    {
        id: 2,
        question: 'What types of Urbania vans are available for rent in Pune?',
        answer: 'Samarth Travels offers 13+1 and 17+1 seater Force Urbania vans. These vans are ideal for corporate outings, weddings, family trips, or airport transfers and come with AC, pushback seats, and ample luggage space.',
    },
    {
        id: 3,
        question: 'What are the rental charges for Urbania vans in Pune?',
        answer: 'Rental charges typically start from ₹35/km for the 13-seater and ₹36/km for the 17-seater Urbania. Local packages such as 4 hours/35 km and 8 hours/80 km are also available at competitive prices. Outstation trips are charged per day with minimum km usage.',
    },
    {
        id: 4,
        question: 'Are Force Urbania vans comfortable for long journeys?',
        answer: 'Yes, Force Urbania vans are designed for long-distance comfort. They come with recliner seats, AC, reading lights, USB charging ports, and personal air vents, making them perfect for group travel.',
    },
    {
        id: 5,
        question: 'Can I customize pickup and drop-off points with Urbania rental?',
        answer: 'Absolutely! Samarth Travels allows complete customization of pickup and drop-off points based on your schedule and convenience to ensure a seamless experience for your group.',
    },
    {
        id: 6,
        question: 'Do Urbania rentals include a driver and fuel?',
        answer: 'Yes, all Urbania rentals from Samarth Travels include a professional driver and fuel. Additional charges such as tolls and parking will be shared upfront for transparency.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for Urbania rentals?',
        answer: 'Yes, Samarth Travels offers 24/7 support for all vehicle rentals, including Force Urbania vans. You can reach us anytime for booking assistance or changes in your travel plan.',
    },
];

const testimonials = [
    {
        name: 'Mr. Karan Joshi',
        role: 'Corporate HR Manager',
        text: 'We hired a 17-seater Urbania from Samarth Travels for a corporate team outing. The van was luxurious and well-maintained. Everyone had a comfortable ride, and the booking process was seamless. Highly recommended!',
        image: '/img/testimonial/testi_urbania_karan.jpg',
    },
    {
        name: 'Mrs. Neha Kulkarni',
        role: 'Family Trip Organizer',
        text: 'Booked a 13-seater Urbania for a weekend trip to Mahabaleshwar. The van was clean, spacious, and came with all modern amenities. Our driver was courteous and punctual. Samarth Travels made our trip truly enjoyable.',
        image: '/img/testimonial/testi_urbania_neha.jpg',
    },
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/urbania-on-rent-pune.jpg",
  "description": "Rent a luxury Urbania vehicle in Pune for weddings, corporate events, city tours, picnics, family trips, and more. Affordable rental services for local and outstation travel, including airport transfers, group travel, and long trips.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "25000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/urbania-on-rent-pune"
  }
};



    return (
        <div>


<Helmet>
  <title>Urbania On Rent in Pune | Luxury & Affordable Vehicle Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury Urbania vehicle in Pune for weddings, corporate events, city tours, picnics, family trips, and more. Affordable rental services for local and outstation travel, including airport transfers, group travel, and long trips." 
  />
  <meta 
    name="keywords" 
    content="Urbania on rent in Pune, Urbania rental services in Pune, Urbania vehicle hire Pune, Urbania on rent for weddings in Pune, Urbania rent for corporate events Pune, Luxury Urbania on rent in Pune, Urbania 14 seater on rent in Pune, Urbania for city tours in Pune, Urbania hire in Pune for picnics, Urbania on rent Pune to Outstation, Urbania rental price in Pune, Urbania bus hire Pune, Urbania for local sightseeing in Pune, Urbania for airport transfers Pune, Urbania for family trips in Pune, Urbania for group travel Pune, Urbania rent for long trips Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpune;